import React from 'react';

const IsActive = ({ rowData }) => {
    return (
        <span 
        className={`${rowData.is_active ? 
        "text-green-500" : 
        "text-red-400"}`}
        >
            {rowData.is_active ? "فعال" : "غیرفعال"}
        </span>
    );
}

export default IsActive;
